import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { BrokerBlacklistEntry } from "../../../api/brokerBlacklistService";

export default function BrokerBlacklistDetails({
  entry,
  onClose,
}: {
  entry: BrokerBlacklistEntry | null;
  onClose: () => void;
}) {
  return (
    <Dialog open={!!entry} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {entry?.name} — {entry?.list} blacklist
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ overflowWrap: "anywhere" }}>
          <Typography>
            {[entry?.address, entry?.email, entry?.domain]
              .filter(Boolean)
              .join(" · ")}
          </Typography>
          <Typography>
            MC: {entry?.mcNumber || "Not provided"} · DOT:{" "}
            {entry?.dotNumber || "Not provided"}
          </Typography>
          <Typography variant="subtitle2">Blacklist reason</Typography>
          <Typography sx={{ whiteSpace: "pre-wrap" }}>
            {entry?.reason || "No reason provided."}
          </Typography>
          <Typography variant="subtitle2">Source email</Typography>
          <Typography sx={{ whiteSpace: "pre-wrap" }}>
            {entry?.sourceEmail || "No source email provided."}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
